import { render, staticRenderFns } from "./electricFireDia.vue?vue&type=template&id=737012c2&scoped=true&"
import script from "./electricFireDia.vue?vue&type=script&lang=js&"
export * from "./electricFireDia.vue?vue&type=script&lang=js&"
import style0 from "./electricFireDia.vue?vue&type=style&index=0&id=737012c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737012c2",
  null
  
)

export default component.exports